export type bizLink = {
	type: 'url' | 'next_journey_item' | 'legacy_state';
	href?: string;
	target?: string;
};

export type bizLinkLegacy = {
	LinkType: 'STATE' | 'URL' | 'NEXT_JOURNEY_ITEM';
	Link?: string;
};

export const convertLegacyLink = (legacyLink: bizLinkLegacy): bizLink => {
	const { LinkType, Link } = legacyLink;
	switch (LinkType) {
		case 'STATE':
			return {
				type: 'legacy_state',
				href: Link,
			};
		case 'URL':
			return {
				type: 'url',
				href: Link,
			};
		case 'NEXT_JOURNEY_ITEM':
			return {
				type: 'next_journey_item',
			};
		default:
			throw new Error(`Unsupported LinkType: ${LinkType}`);
	}
};
